import { useEffect, useState } from "react";
import { IServiceEvent } from "../types/IServiceEvent";
import getLatestRuns from "../utils/utils";
import { Spinner } from "@idwal/idwal-react-components";

/**
 * Main header component
 */
export const EventCardFooter = (props: {
    events: IServiceEvent[] | null;
    errors: IServiceEvent[] | null;
}) => {
    const [lastSuccessTime, setLastSuccessTime] = useState<string | null>(
        "None"
    );
    const [lastErrorTime, setLastErrorTime] = useState<string | null>("None");

    useEffect(() => {
        if (props.events) {
            getFooter(props.events);
        }
    }, [props.events, props.errors]);

    function getFooter(events: IServiceEvent[]) {
        const latest = getLatestRuns(events);

        if (latest.lastSuccess) {
            const datetime = new Date(parseInt(latest.lastSuccess));
            setLastSuccessTime(
                datetime.toLocaleDateString() +
                    ":" +
                    datetime.toLocaleTimeString()
            );
        }

        if (latest.lastError) {
            const datetime = new Date(parseInt(latest.lastError));
            setLastErrorTime(
                datetime.toLocaleDateString() +
                    ":" +
                    datetime.toLocaleTimeString()
            );
        }
    }

    return (
        <div className="flex">
            <small>
                Last successful run:
                {props.events ? (
                    <span> {lastSuccessTime}</span>
                ) : (
                    <span className="ml-2">
                        <Spinner width={10} height={10} />
                    </span>
                )}
            </small>
            <small
                style={{
                    color: props.errors && props.errors?.length > 0 ? "red" : ""
                }}
                className="ml-4"
            >
                Last failure:
                {props.events ? (
                    <span> {lastErrorTime}</span>
                ) : (
                    <span className="ml-2">
                        <Spinner width={10} height={10} />
                    </span>
                )}
            </small>
        </div>
    );
};
